import { NotePage } from '../NotePage/NotePage';
import { PlateletRichPlasmaParagraphs } from './Paragraphs';

export const PlateletRichPlasma = () => (
  <NotePage
    title="What to know about platelet-rich plasma"
    eyebrow="Wellness note"
    summary="A simple explanation of platelets, recovery language, and why an individualized clinical assessment matters before considering any next step."
    paragraphs={PlateletRichPlasmaParagraphs}
    relatedTitle="Platelet Rich Plasma"
    appointmentServiceValue="Platelet Rich Plasma"
  />
);
